// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Merriweather_Sans_4f90b0', '__Merriweather_Sans_Fallback_4f90b0'","fontStyle":"normal"},"className":"__className_4f90b0"};